import { useTranslation } from "react-i18next";
import { Icon, cn } from "@nexus/ui";
import { isNavigableUrl } from "@/features/opportunities/lib/original-brief-url";

interface OriginalBriefLinkProps {
  url: string;
  className?: string;
}

export function OriginalBriefLink({ url, className }: OriginalBriefLinkProps) {
  const { t } = useTranslation();

  if (!isNavigableUrl(url)) {
    return (
      <p className={cn("text-xs leading-relaxed text-foreground/85 break-all", className)}>
        {url}
      </p>
    );
  }

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className={cn(
        "inline-flex items-center gap-1.5 text-xs font-medium text-primary underline-offset-2 hover:underline",
        className,
      )}
      aria-label={t("opportunities.scripts.viewOriginalBriefAria", { url })}
    >
      <span>{t("opportunities.scripts.viewOriginalBrief")}</span>
      <Icon name="external-link" size="xs" className="shrink-0 text-current" aria-hidden />
    </a>
  );
}
